module.exports = __webpack_public_path__ + "static/img/图层 544.d3edef16.png";